import { useEffect, useState } from 'react';
import {
  ShieldCheck, LogOut, ChevronRight,
  Settings, Bot, Sparkles, Clock, LayoutGrid, Palette, Type, LayoutDashboard, HardDrive, Cpu, CheckSquare,
  MessageSquare, List, CalendarDays, Calendar, Key,
  type LucideIcon, BarChart3, Mail} from '../../icons';
import { UserCheck } from '../../icons';
// 앱 배포 (2026-09-14) — 운영자 전용 「앱」 그룹.
import { Smartphone } from '../../icons';
// 외부 API (2026-09-21) — 바깥 서비스를 부르는 자리.
import { Globe } from '../../icons';
import { useAdminAuthStore } from '../../store/adminAuthStore';
import { adminLogout } from '../../api/auth';
import { SessionTimer } from './SessionTimer';
import { DashboardSection } from './sections/DashboardSection';
/**
 * 서비스 관리 — 2026-09-09 목록 공통 규격 채택본. 세로로 쌓여 있던 카드 격자 세 절을
 * 좌 분류(내장 · 사용자 정의 · 외부 연결)로 접었다. 이전 화면은 파일로 남겨 뒀다.
 */
import { ServiceListSection } from './sections/ServiceListSection';
/**
 * 메뉴 관리 — 2026-09-09 **콘솔 목록 공통 규격 채택본**으로 갈아탔다(사용자 지시).
 *   이전 화면(MenuRegistrySection · 카드 격자)은 되돌리기 대비로 파일을 남겨 뒀고,
 *   편집 폼(MenuModal)은 그 파일 것을 새 화면이 그대로 쓴다.
 */
import { MenuListSection } from './sections/MenuListSection';
/** 아이콘 관리 — 2026-09-09 목록 공통 규격 채택본. 이전 격자 화면은 파일로 남겨 뒀다. */
import { IconListSection } from './sections/IconListSection';
// 글꼴 관리 — 좌 가족 목록 / 우 미리보기·얼굴로 교체 (2026-08-20).
// 이전 화면(FontRegistrySection)은 롤백 대비로 파일을 남겨 뒀다.
import { FontWorkspace } from './sections/FontWorkspace';
import { AiTimeoutSection } from './sections/AiTimeoutSection';
// 사용자 관리 — **2026-08-25 콘솔에서 뺐다**(사용자 지시). 회사 관리자의 일이라
//   8443 통합설정 › 회사 관리 › 사용자 관리로 넘겼다(같은 화면·같은 서버 라우트라 잃는 기능 0).
//   ⚠ `sections/UserWorkspace.tsx`·`.css` 파일은 **지우지 않는다** — 롤백 대비이기도 하지만,
//     그 css 의 `um-*` 를 예약관리·워크스페이스·글꼴 화면이 지금도 import 한다.
// 계정 관리 (2026-08-25) — 관리 콘솔에 들어올 수 있는 사람 명단. 로그인 관문의 SSOT.
/**
 * 계정 관리 — 2026-09-09 목록 공통 규격 채택본. 표 안에서 줄이 열리던 인라인 편집을
 * 팝업으로 옮겼다(정본 P3-1 금지 사항). 이전 화면은 파일로 남겨 뒀다.
 */
import { ConsoleAccountListSection } from './sections/ConsoleAccountListSection';
// 알림 설정 — **2026-08-25 콘솔에서 뺐다**(사용자 지시). 사용자 관리와 같은 이유다:
//   ① 개인 층('본인 수신 거부')은 로그인한 사람 자기 이메일 설정이고,
//   ② 회사 전체 층은 **로그인한 사람의 institution** 만 끈다 — 회사를 고르는 길이 없어
//      운영자가 고객사 것을 건드릴 수 없다. 둘 다 콘솔(운영자 전용)에서 할 일이 아니다.
//   자리는 8443 통합설정 › 회사 관리 › 알림 설정 하나다. 파일은 롤백 대비로 남겨 뒀다.
import { SystemUserMaintenance } from './sections/SystemUserMaintenance';
import { AiProviderSection } from './sections/AiProviderSection';
// 판 H-② — 회사가 고를 수 있는 것을 «연다».
import { AiOpenCatalogSection } from './sections/AiOpenCatalogSection';
import { AiUsageSection } from './sections/AiUsageSection';
import { SystemMailSection } from './sections/SystemMailSection';
// 시스템 설정 › HR 연동 점검 (2026-09-14) — 사원번호 하나로 HR 연동이 답하는지 본다(읽기 전용).
import { HrPreflightSection } from './sections/HrPreflightSection';
// 앱 배포 (2026-09-14) — 설치 파일(APK) 등록 · 게시 · 회수 + 기관별 배포 방식. 계약 「안 A」(콘솔) 구현.
import { AppReleaseSection } from './sections/AppReleaseSection';
import { ExternalApiSection } from './sections/ExternalApiSection';
import { AiToolsSection } from './sections/AiToolsSection';
/**
 * AI 도구(신) — 2026-09-09 목록 공통 규격 채택본(사용자 지시). **옛 화면과 나란히 둔다** —
 *   둘을 눈으로 견준 뒤 옛 것을 내리는 순서다. 부르는 라우트가 같아 데이터는 한 곳이다.
 */
import { AiToolsListSection } from './sections/AiToolsListSection';
import { AiAnswerToneSection } from './sections/AiAnswerToneSection';
import { AiAnswerFormatSection } from './sections/AiAnswerFormatSection';
import { CalendarThemeSection } from './sections/CalendarThemeSection';
// 회사 기본 테마(2026-08-20) — 직원이 처음 보는 화면 색 + 개인 변경 허용 정책.
import { HolidaySection } from './sections/HolidaySection';
import './AdminConsolePage.css';
// 워크스페이스 관리 — **회사에 줄 전체 용량만** (2026-08-25 사용자 결정).
//   나누는 일(부서·팀·개인)은 회사 것이라 8443 통합설정 › 회사 관리로 갔다.
//   이전 두 화면(WorkspaceAdminSection · WorkspaceQuotaWorkspace)은 롤백 대비로 남겨 뒀다.
import { WorkspaceCompanySection } from './sections/WorkspaceCompanySection';
/**
 * ★★ 2026-09-09 (사용자 지시) — **회사정보 · 예약관리 · 게시판 관리를 콘솔에서 뺐다.**
 *
 * 셋 다 **회사가 자기 것을 정하는 일**이라 운영자 콘솔의 일이 아니다. 이미 8443
 * 통합설정 › 회사 관리에 같은 화면이 있고(같은 서버 라우트를 부른다) 거기서 회사
 * 관리자가 고친다 — 콘솔에서 지워도 잃는 기능이 0 이다.
 *   · 회사정보    → 8443 통합설정 › 회사 관리 › 회사정보
 *   · 예약관리    → 8443 통합설정 › 회사 관리 › 예약관리
 *   · 게시판 관리 → 8443 통합설정 › 회사 관리 › 게시판 관리
 * 항목이 하나뿐이던 **「회사」 그룹은 통째로 사라진다**(빈 그룹 라벨을 남기지 않는다).
 *
 * ⚠ `sections/CompanyInfoSection.tsx` · `ReservationWorkspace.tsx` · `BoardAdminSection.tsx`
 *   (와 그 짝인 `CompanyLogoGroup`·`ReservationAdminSection`)는 **지우지 않는다** — 사용자
 *   관리·알림 설정을 뺐을 때와 같은 이유다(롤백 대비 + 남의 화면이 그 css 를 import 한다).
 *   서버(admin BFF) 라우트도 그대로 둔다 — 8443 이 쓰는 chat-server SSOT 와 별개이고,
 *   지우면 되돌리기가 어려워진다.
 */
import './ConsolePage.css';

type Tab =
  | 'dashboard'
  | 'modules' | 'menu' | 'icon' | 'font' | 'calendar-theme' | 'holidays' | 'ai-provider' | 'ai-open-catalog' | 'ai-usage' | 'sys-mail' | 'ai-tools' | 'ai-tone' | 'ai-format' | 'ai-timeout'
  | 'console-accounts'
  // AI 도구(신) — 목록 공통 규격 채택본. 옛 'ai-tools' 와 나란히 산다(2026-09-09).
  | 'ai-tools-new'
  // 워크스페이스 관리 (2026-08-12) — 회사 전체 자원 + 개인별/팀별 용량 한도.
  | 'workspace-manage'
  // 유지보수 › 사용자 관리 (운영자 전용) — 회사를 골라 비밀번호만 재설정. 화면 L · 결정 ⑧.
  | 'sys-user-maint'
  // 시스템 설정 › HR 연동 점검 (2026-09-14, 운영자 전용).
  | 'sys-hr'
  // 앱 › 앱 배포 (2026-09-14, 운영자 전용) — 인스턴스 전역 표라 회사 관리자 것이 아니다.
  | 'app-release'
  // 시스템 설정 › 외부 API (2026-09-21, 운영자 전용) — 날씨 · 주소 키는 인스턴스에 한 벌이다.
  | 'external-api';

interface TabDef { key: Tab; label: string; icon: LucideIcon }
interface GroupDef { key: string; label: string; tabs: TabDef[] }

// admin 콘솔 그룹/탭 — 설계의 ai 그룹 포함(AI Provider/도구가 여기로 이전됨).
// 시안 2(Collapsible Icon Rail): 각 탭에 아이콘 부여 — 접힘 상태에서 아이콘만 노출.
const GROUPS: GroupDef[] = [
  { key: 'overview', label: '개요', tabs: [
    { key: 'dashboard', label: '대시보드', icon: LayoutDashboard },
  ] },
  { key: 'integration', label: '서비스', tabs: [
    { key: 'menu', label: '메뉴 관리', icon: LayoutGrid },
    /**
     * 2026-08-25 (사용자 지시) — 서비스 관리는 **메뉴 관리 바로 밑**에 온다.
     * 잠깐 운영자 그룹에 있었는데(#666) 자리를 여기로 되돌렸다. 역할 게이트는 함께 뗐다 —
     * 콘솔은 이제 **계정 관리 명단**으로 들어올 사람을 가리므로 탭마다 다시 가릴 이유가 없다.
     */
    { key: 'modules', label: '서비스 관리', icon: Settings },
    { key: 'icon', label: '아이콘 관리', icon: Palette },
    // 글꼴 관리 (2026-08-18) — 문서가 쓰는 글꼴을 회사가 등록한다(편집기·미리보기가 받아 쓴다).
    { key: 'font', label: '글꼴 관리', icon: Type },
    { key: 'calendar-theme', label: '캘린더 테마', icon: CalendarDays },
    { key: 'holidays', label: '공휴일 관리', icon: Calendar },
    // ⚠ 여기 항목을 더하거나 빼면 아래 Alt+1..9 단축키의 flat 인덱스가 밀린다.
    //   2026-09-09 정리 기준 flat 순서 = 대시보드 · 메뉴 · 서비스 · 아이콘 ·
    //   글꼴 · 캘린더 테마 · 공휴일 · 계정 관리.
    //   단축키 매핑은 화면 어디에도 표기되지 않아 영향이 작다고 판단해 그룹 의미를 우선한다.
  ] },
  { key: 'user', label: '사용자', tabs: [
    // 계정 관리 — 콘솔에 들어올 수 있는 사람 명단. 로그인 관문의 SSOT.
    //   ★ '사용자 관리' 는 2026-08-25 에 **8443 으로 넘겼다** — 계정 관리와 사용자 관리는
    //     다른 일이다. 여기는 "콘솔 열쇠", 저기는 "회사 직원 명부".
    { key: 'console-accounts', label: '계정 관리', icon: ShieldCheck },
  ] },
];

/**
 * 운영자(SYSTEM_ADMIN) 에게만 보이는 그룹 — 고객사 계정을 여는 일은 회사 관리자의 일이 아니다.
 * GROUPS 는 그대로 두고 **덧붙이기만** 한다(회사 관리자 화면은 한 줄도 안 바뀐다).
 */
const OPS_GROUPS: GroupDef[] = [
  { key: 'maintenance', label: '기업회원', tabs: [
    // 2026-08-25 — '유지보수 › 사용자 관리' 를 **기업회원 › 기업회원관리** 로 고쳤다.
    //   키(`maintenance`·`sys-user-maint`)는 내부 식별자라 그대로 둔다(바꿔도 얻는 게 없다).
    { key: 'sys-user-maint', label: '기업회원관리', icon: Key },
    /**
     * ★★ 2026-08-25 (사용자 지시) — 워크스페이스 관리는 **회사용·시스템용으로 갈렸다**.
     *    여기 것은 시스템용 — 회사에 **얼마를 주느냐**를 정하는, 서비스 운영자의 일이다.
     *    받은 용량을 부서·팀·개인에게 나누는 일(회사용)은 8443 통합설정 › 회사 관리에 있다.
     *    → 회사 관리자는 여기서 잃는 것이 없다. 회사 전체 용량은 그 회사용 화면에서도 보인다.
     */
    { key: 'workspace-manage', label: '워크스페이스 관리', icon: HardDrive },
  ] },
  /**
   * ★★ 2026-09-10 (사용자 지시) — **시스템 설정**. 지금까지 서버 파일(`.env`)에만 있어
   *    사람이 못 고치던 값들을 여기서 정한다. 서버 한 벌짜리 값이라 운영자 것이다.
   *    ★ 표에 줄이 없으면 종전대로 `.env` 가 답한다(회귀 0) — 화면이 그 사실을 적는다.
   */
  { key: 'system', label: '시스템 설정', tabs: [
    { key: 'sys-mail', label: '메일', icon: Mail },
  ] },
  /**
   * ★★ 2026-09-14 — **앱 배포**. 설치 파일(APK)은 인스턴스에 한 벌이라(표에 institution_id 가 없다) 운영자 것이다.
   *    「시스템 설정」 그룹에 넣지 않은 이유: 그 그룹은 메일 → HR 연동 점검 순서가 검사로 못 박혀 있고(#1317),
   *    앱 배포는 「.env 값을 화면으로」 라는 그 그룹의 뜻과도 다르다(파일 · 상태 · 감사가 있는 «일»이다).
   */
  { key: 'app', label: '앱', tabs: [
    { key: 'app-release', label: '앱 배포', icon: Smartphone },
  ] },
  /**
   * ★★ 2026-08-24 — AI 설정은 **서버·오케스트레이터 전역**이라 운영자 것이다.
   *    한 회사가 provider·도구·톤·타임아웃을 바꾸면 **모든 회사가 바뀌고**, `.env` 까지 쓴다.
   *    회사가 자기 AI 를 붙이는 자리는 따로 있다(`llm_integrations`).
   */
  { key: 'ai', label: 'AI', tabs: [
    { key: 'ai-provider', label: 'AI Provider', icon: Bot },
    // 판 H-② — 여기서 «연» 것만 회사 관리자(8443 통합설정)에게 보인다.
    { key: 'ai-open-catalog', label: 'AI 연결', icon: CheckSquare },
    /* 판 K — 「총사용량, 회사별, 모델별 집계」(2026-09-10 사용자 지시). */
    { key: 'ai-usage', label: 'AI 사용량', icon: BarChart3 },
    { key: 'ai-tools', label: 'AI 도구', icon: Sparkles },
    { key: 'ai-tools-new', label: 'AI 도구(신)', icon: Cpu },
    { key: 'ai-tone', label: '답변 톤', icon: MessageSquare },
    { key: 'ai-format', label: '답변 포맷', icon: List },
    { key: 'ai-timeout', label: 'AI 타임아웃', icon: Clock },
  ] },
];

/**
 * 운영자 전용 탭 — **탭을 감추는 것만으로는 부족하다.** 대시보드 바로가기처럼 `setTab` 을
 * 직접 부르는 길이 있어서, 본문 쪽에서도 한 번 더 가른다(서버는 403 으로 최종 판정).
 */
const OPS_ONLY_TABS = new Set<Tab>([
  'sys-user-maint', 'ai-provider', 'ai-open-catalog', 'ai-usage', 'sys-mail', 'ai-tools', 'ai-tools-new', 'ai-tone', 'ai-format', 'ai-timeout',
  // 외부 API (2026-09-21) — 키 한 벌을 전 회사가 나눠 쓴다. 회사 관리자가 열면 아래 안내가 나간다.
  'external-api',
  // 2026-08-25 — 워크스페이스 관리(회사에 줄 전체 용량)는 운영자의 일이다.
  //   ★ 서비스 관리는 여기서 뺐다 — 서비스 그룹으로 자리를 옮겼는데, 그 그룹은 모두에게
  //     그려지므로 남겨 두면 "탭은 보이는데 본문은 막히는" 상태가 된다.
  'workspace-manage',
  // 2026-09-14 — 앱 배포는 인스턴스 전역(SYSTEM_ADMIN API)이다.
  'app-release',
]);

/**
 * 2026-09-14 — **시스템 설정 › HR 연동 점검**은 회사 관리자(ADMIN)와 운영자 **모두**의 탭이다(#1317 리뷰 · 관제 결정).
 *   HR 연동은 **회사(기관)마다** 붙이는 설정이고 서버 라우트도 ADMIN 을 허용한다 — 점검 대상은 로그인한 계정의 회사다.
 *   ★ 운영자 화면의 탭 순서는 그대로 둔다: 운영자에게는 기존 「시스템 설정」 그룹(메일) **뒤에 붙이고**,
 *     회사 관리자에게는 GROUPS 뒤에 이 탭 하나짜리 「시스템 설정」 그룹을 붙인다(같은 라벨이 두 번 그려지지 않게).
 */
const SHARED_SYSTEM_TABS: TabDef[] = [
  { key: 'sys-hr', label: 'HR 연동 점검', icon: UserCheck },
];

/**
 * 시스템 설정 그룹의 **꼬리** — 운영자에게만 보이는 탭 (2026-09-21).
 *
 * ★ 「메일 → HR 연동 점검」 순서는 검사가 못 박고 있다(#1317). 그 사이에 끼우지 않고 **뒤에 붙인다.**
 * ★ 외부 API 키는 **인스턴스에 한 벌**이라(전 회사가 나눠 쓴다) 회사 관리자 것이 아니다 — 서버도 SYSTEM_ADMIN 만 받는다.
 */
const OPS_SYSTEM_TAIL_TABS: TabDef[] = [
  { key: 'external-api', label: '외부 API', icon: Globe },
];

function buildGroups(isOps: boolean): GroupDef[] {
  if (!isOps) return [...GROUPS, { key: 'system', label: '시스템 설정', tabs: SHARED_SYSTEM_TABS }];
  return [
    ...GROUPS,
    ...OPS_GROUPS.map((g) => (g.key === 'system' ? { ...g, tabs: [...g.tabs, ...SHARED_SYSTEM_TABS, ...OPS_SYSTEM_TAIL_TABS] } : g)),
  ];
}

/**
 * 운영자 전용 탭을 회사 관리자가 열었을 때의 안내 — **왜 여기 없는지와 어디로 가면 되는지**를
 * 탭마다 다르게 말한다. 하나로 뭉뚱그리면(예: 전부 "AI 연동은 서비스 관리에서") 워크스페이스처럼
 * AI 와 무관한 탭에서 엉뚱한 안내가 나간다.
 */
function opsOnlyNotice(tab: Tab): JSX.Element {
  if (tab === 'external-api') {
    return (
      <>
        이 화면은 <b>서비스 운영자</b>가 다룹니다 — 날씨 · 주소 검색 키는 <b>인스턴스에 한 벌</b>이라 전 회사가 함께 씁니다.
        회사별로 끄고 켜는 것은 운영자에게 요청하십시오.
      </>
    );
  }
  if (tab === 'app-release') {
    return (
      <>
        이 화면은 <b>서비스 운영자</b>가 다룹니다 — 설치 파일(APK)은 인스턴스 전체에 한 벌이라 회사별로 갈라지지 않습니다.
        사원은 사용자 사이트의 <b>설정 › 앱 다운로드</b> 에서 받습니다.
      </>
    );
  }
  if (tab === 'workspace-manage') {
    return (
      <>
        이 화면은 <b>서비스 운영자</b>가 다룹니다 — 회사에 <b>얼마를 줄지</b> 정하는 자리입니다.
        받은 용량을 부서·팀·개인에게 나누는 일은 사용자 사이트의
        <b> 통합설정 › 회사 관리 › 워크스페이스 관리</b> 에서 합니다.
      </>
    );
  }
  return (
    <>
      이 화면은 <b>서비스 운영자</b>가 다룹니다 — 서버 전체에 적용되는 설정이라 회사별로 갈라지지 않습니다.
      회사에서 쓸 AI 연동은 <b>서비스 관리</b>에서 설정합니다.
    </>
  );
}

const PIN_KEY = 'admin.console.sidebar.pinned';

export function ConsolePage() {
  const user = useAdminAuthStore((s) => s.user);
  const clearSession = useAdminAuthStore((s) => s.clearSession);
  const [tab, setTab] = useState<Tab>('dashboard');
  // 펼침 고정(pin) — 레일 토글로 켜고/끄며 localStorage 에 유지. 미고정 시 hover 로만 임시 펼침.
  const [pinned, setPinned] = useState<boolean>(() => {
    try { return localStorage.getItem(PIN_KEY) === '1'; } catch { return false; }
  });

  function togglePin() {
    setPinned((prev) => {
      const next = !prev;
      try { localStorage.setItem(PIN_KEY, next ? '1' : '0'); } catch { /* */ }
      return next;
    });
  }

  // 운영자면 유지보수 그룹이 뒤에 붙는다 — 회사 관리자에게는 GROUPS 뒤에 「시스템 설정 › HR 연동 점검」 하나만 붙는다
  //   (GROUPS 의 기존 인덱스·Alt 번호는 그대로, ADMIN 은 Alt+9 = HR 연동 점검이 새로 생긴다 — 2026-09-14).
  const isOps = user?.role === 'SYSTEM_ADMIN';
  // 2026-09-14 — 공용 시스템 설정 탭(HR 연동 점검)을 끼우려고 buildGroups 로 묶었다(종전: isOps ? [...GROUPS, ...OPS_GROUPS] : GROUPS).
  const groups = buildGroups(isOps);
  // Alt+1..N 단축키 — flat tab 인덱스.
  const flatTabs = groups.flatMap((g) => g.tabs);
  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      const t = e.target as HTMLElement | null;
      if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) return;
      if (e.altKey && e.key >= '1' && e.key <= '9') {
        const idx = Number(e.key) - 1;
        if (flatTabs[idx]) { e.preventDefault(); setTab(flatTabs[idx]!.key); }
      }
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function handleLogout() {
    try { await adminLogout(); } catch { /* */ }
    clearSession();
  }

  // breadcrumb 용 현재 그룹/탭 라벨.
  const activeGroup = groups.find((g) => g.tabs.some((t) => t.key === tab));
  const activeTab = flatTabs.find((t) => t.key === tab);

  return (
    <div className="admin-console" data-pinned={pinned || undefined}>
      <aside className="admin-console__sidebar admin-console__rail">
        {/* 우측 경계 중앙 화살표 토글 — 클릭 시 펼침/접힘(8443 동형). */}
        <button
          type="button"
          className="admin-console__edge-toggle"
          onClick={togglePin}
          aria-label={pinned ? '사이드바 접기' : '사이드바 펼치기'}
          aria-pressed={pinned}
          title={pinned ? '사이드바 접기' : '사이드바 펼치기'}
        >
          <ChevronRight size={16} />
        </button>
        <div className="admin-console__rail-head">
          <span className="admin-console__brand">
            <ShieldCheck size={18} />
            <span className="admin-console__label">관리 콘솔</span>
          </span>
        </div>

        <nav className="admin-console__tabs admin-console__rail-nav" role="tablist">
          {groups.map((g) => (
            <div key={g.key} className="admin-console__group">
              <div className="admin-console__group-label">{g.label}</div>
              {g.tabs.map((t) => {
                const Icon = t.icon;
                const active = tab === t.key;
                return (
                  <button
                    key={t.key}
                    role="tab"
                    aria-selected={active}
                    title={t.label}
                    className={`admin-console__tab admin-console__rail-tab${active ? ' admin-console__tab--active' : ''}`}
                    onClick={() => setTab(t.key)}
                  >
                    <Icon size={18} className="admin-console__rail-icon" />
                    <span className="admin-console__label">{t.label}</span>
                  </button>
                );
              })}
            </div>
          ))}
        </nav>

        <SessionTimer />

        <div className="admin-console__user admin-console__rail-user">
          <span className="admin-console__user-name admin-console__label">
            {user?.name ?? user?.email}
          </span>
          <button
            type="button"
            className="admin-console__logout"
            onClick={handleLogout}
            title="로그아웃"
            aria-label="로그아웃"
          >
            <LogOut size={16} />
            <span className="admin-console__label">로그아웃</span>
          </button>
        </div>
      </aside>

      <main className="admin-console__content admin-console__rail-content" role="tabpanel">
        <div className="admin-console__crumb">
          <span>관리 콘솔</span>
          {activeGroup && <span className="admin-console__crumb-sep">›</span>}
          {activeGroup && <span>{activeGroup.label}</span>}
          {activeTab && <span className="admin-console__crumb-sep">›</span>}
          {activeTab && <b>{activeTab.label}</b>}
        </div>

        <div className="admin-console__panel">
          {!isOps && OPS_ONLY_TABS.has(tab) ? (
            <div className="admin-console__alert" role="status">{opsOnlyNotice(tab)}</div>
          ) : (
          <>
          {tab === 'dashboard' && <DashboardSection opsAllowed={isOps} onNavigate={(t) => setTab(t as Tab)} />}
          {/* 2026-09-17 — 「사용자 정의」·「외부 연결」 두 갈래는 운영자만(서버도 403 으로 잠겼다).
              탭 자체는 감추지 않는다 — 첫 갈래 「내장 서비스」는 회사 관리자의 정당한 기능이다. */}
          {tab === 'modules' && <ServiceListSection opsAllowed={isOps} />}
          {tab === 'menu' && <MenuListSection />}
          {tab === 'icon' && <IconListSection />}
          {tab === 'font' && <FontWorkspace />}
          {tab === 'calendar-theme' && <CalendarThemeSection />}
          {tab === 'holidays' && <HolidaySection />}
          {tab === 'workspace-manage' && <WorkspaceCompanySection />}
          {tab === 'ai-provider' && <AiProviderSection />}
          {tab === 'ai-open-catalog' && <AiOpenCatalogSection />}
          {tab === 'ai-usage' && <AiUsageSection />}
          {tab === 'sys-mail' && <SystemMailSection />}
          {tab === 'sys-hr' && <HrPreflightSection />}
          {tab === 'app-release' && <AppReleaseSection />}
          {tab === 'external-api' && <ExternalApiSection />}
          {tab === 'ai-tools' && <AiToolsSection />}
          {tab === 'ai-tools-new' && <AiToolsListSection />}
          {tab === 'ai-tone' && <AiAnswerToneSection />}
          {tab === 'ai-format' && <AiAnswerFormatSection />}
          {tab === 'ai-timeout' && <AiTimeoutSection />}
          {tab === 'console-accounts' && <ConsoleAccountListSection />}
          {/* 운영자 전용 — 탭 자체가 SYSTEM_ADMIN 에게만 보이고, 권한 판정은 서버가 한다. */}
          {tab === 'sys-user-maint' && <SystemUserMaintenance />}
          </>
          )}
        </div>
      </main>
    </div>
  );
}
